import {useTranslation} from "react-i18next";
import {Divider, Grid, Stack, Switch, TextInput} from "@mantine/core";
import {useCustomFieldDefFormContext} from "./useCustomFieldDefForm";
import {CustomFieldDefFormProps} from "./CustomFieldDefForm";
import {customFieldDefDataType} from "@ots-frontend/ots-data";
import {CompanySelect} from "../../select/entity/CompanySelect/CompanySelect";
import {EntityTypeSelect} from "../../select/entity/EntityTypeSelect/EntityTypeSelect";
import {
  CustomFieldDefDataTypeSelect
} from "../../select/entity/CustomFieldDefDataTypeSelect/CustomFieldDefDataTypeSelect";

export type CustomFieldDefFormFieldProps = Pick<CustomFieldDefFormProps, 'options'> & {}

export const CustomFieldDefFormFields = (props: CustomFieldDefFormFieldProps) => {
  const {
    options,
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useCustomFieldDefFormContext();

  return (
    <Stack spacing="xs">
      <Grid>
        <Grid.Col span={6}>
          <CompanySelect
            size="xs"
            label={t("common.entity.customfielddef.form.field.company", "Company")}
            placeholder={t<string>("common.entity.customfielddef.form.field.company.placeholder", "Company")}
            disabled={options?.companySelectDisabled}
            selector={{
              regionId: options?.regionId,
            }}
            withAsterisk
            required
            clearable
            {...form.getInputProps("company")} />
        </Grid.Col>
        <Grid.Col span={6}>
          <EntityTypeSelect
            size="xs"
            label={t("common.entity.customfielddef.form.field.objecttype", "Entity Type")}
            placeholder={t<string>("common.entity.customfielddef.form.field.objecttype.placeholder", "Entity Type")}
            withAsterisk
            required
            clearable
            {...form.getInputProps("objectType")} />
        </Grid.Col>
      </Grid>

      <Divider label="Field" labelPosition="left" variant="dotted" mt="md" mb="sm"/>

      <CustomFieldDefDataTypeSelect
        size="xs"
        label={t("common.entity.customfielddef.form.field.datatype", "Data Type")}
        placeholder={t<string>("common.entity.customfielddef.form.field.datatype.placeholder", "Data Type")}
        withAsterisk
        required
        clearable
        {...form.getInputProps("dataType")} />

      {form.values.dataType === customFieldDefDataType.ref.code &&
        <EntityTypeSelect
          size="xs"
          label={t("common.entity.customfielddef.form.field.refobjecttype", "Data Entity Type")}
          placeholder={t<string>("common.entity.customfielddef.form.field.refobjecttype.placeholder", "Data Entity Type")}
          withAsterisk
          required
          clearable
          {...form.getInputProps("refObjectType")} />
      }

      <TextInput
        size="xs"
        label={t("common.entity.customfielddef.form.code.label", "Code")}
        description={t("common.entity.customfielddef.form.code.description", "Code is used to identify the field in the API. It must be unique within the company and entity type.")}
        placeholder={t<string>("common.entity.customfielddef.form.field.code.placeholder", "WAIT_TIME")}
        withAsterisk
        required
        {...form.getInputProps('code')}/>

      <Divider label="Configuration" labelPosition="left" variant="dotted" mt="md" mb="sm"/>

      <TextInput
        size="xs"
        label={t("common.entity.customfielddef.form.field.label", "Label")}
        placeholder={t<string>("common.entity.customfielddef.form.field.label.placeholder", "Wait Time")}
        withAsterisk
        required
        {...form.getInputProps('label')}/>

      <Switch
        size="xs"
        mt="md"
        label={t("common.entity.customfielddef.form.field.required", "Required")}
        {...form.getInputProps("required", {type: 'checkbox'})} />

    </Stack>
  )
}
